export const createRatingArrayFrom = (rating) => {
  if (isNaN(rating)) {
    return Array.from(Array(5), (_, i) => 0);
  }

  return Array.from(Array(5), (_, i) => (i <= rating - 1 ? 1 : 0));
};
